export const supportedCurrencies = {
    eur: "EUR",
    usd: "USD",
    uah: "UAH",
    pln: "PLN",
};

export type SupportedCurrency = (typeof supportedCurrencies)[keyof typeof supportedCurrencies];